import React from "react";
import "./Hero.css";

export default function Hero() {

  const handleExploreEvent = () => {
    const isLocalhost = window.location.hostname === "localhost";

    const base = isLocalhost
      ? "http://localhost:3000"
      : "https://tedxsetapak.com";

    window.open(
      `${base}/#/event2/theme`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section className="hero2026">

      {/* Decorative background */}
      <div className="hero2026-background"></div>

      <div className="container hero2026-container">

        <div className="hero2026-content">

          {/* Event Name */}
          <p className="hero2026-event-name">
            TEDxSetapak 2026
          </p>

          {/* Event Theme */}
          <h1 className="hero2026-title">
            T.U.M.B.U.H
          </h1>

          {/* Tagline */}
          <h2 className="hero2026-tagline">
            Change Worth Growing
          </h2>

          {/* Event Date */}
          <div className="hero2026-event-details">
            <span>31 OCTOBER 2026</span>
          </div>

          {/* Description */}
          <p className="hero2026-description">
            Ideas that inspire growth, spark conversations,
            and create meaningful change.
          </p>

          {/* CTA */}
          <button
            type="button"
            className="hero2026-button"
            onClick={handleExploreEvent}
          >
            EXPLORE THE EVENT
            <i
              className="fas fa-arrow-right"
              aria-hidden="true"
            ></i>
          </button>

          {/* Scroll Indicator */}
          <div className="hero2026-scroll">
            <span>DISCOVER MORE</span>
            <i
              className="fas fa-chevron-down"
              aria-hidden="true"
            ></i>
          </div>

        </div>

      </div>

    </section>
  );
}